module.exports = __webpack_public_path__ + "static/images/common-1.ec4d505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/common-1.png
// module id = OHYm
// module chunks = 8